/* Fabric Alex PDP extras visual v9 — solid delivery divider + optically balanced carrier logos */
(function () {
  'use strict';

  var root = document.querySelector('.fa-product-extras');

  var icons = {
    thread: '<svg class="fa-extra-icon fa-extra-icon--thread" viewBox="0 0 32 32" fill="none" aria-hidden="true"><path d="M10.3 7.3h11.4l-1.5 3H11.8l-1.5-3Z" fill="currentColor"/><path d="M11.8 10.1h8.4l1 12H10.8l1-12Z" fill="currentColor" fill-opacity=".22"/><path d="M9 6h14M9 24h14" stroke="currentColor" stroke-width="2.3" stroke-linecap="round"/><path d="M11.2 13h9.6M10.9 16h10.2M10.7 19h10.6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M20.8 21.4c3.9.2 5.3 1.6 4.6 3.3-.5 1.3-2 1.6-3.7 1.3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    half: '<svg class="fa-extra-icon fa-extra-icon--half" viewBox="0 0 32 32" fill="none" aria-hidden="true"><rect x="5.5" y="10" width="21" height="12" rx="3" fill="currentColor" fill-opacity=".12" stroke="currentColor" stroke-width="2"/><path d="M9 10v4M13 10v2.5M17 10v4M21 10v2.5M25 10v4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M9.5 18.2h13" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    twenty: '<svg class="fa-extra-icon fa-extra-icon--twenty" viewBox="0 0 32 32" fill="none" aria-hidden="true"><path d="M7 8.5h18v15H7z" fill="currentColor" fill-opacity=".10" stroke="currentColor" stroke-width="2"/><path d="M10.5 8.7v3.5M14 8.7v2M17.5 8.7v3.5M21 8.7v2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M10.5 18.7h11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="m12 22.7 8-8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity=".5"/></svg>'
  };

  if (root) {
    Object.keys(icons).forEach(function (type) {
      var card = root.querySelector('[data-fa-extra="' + type + '"]');
      if (!card) return;
      var target = card.querySelector('.fa-extra-card__icon');
      if (target) target.innerHTML = icons[type];
    });
  }

  var configNode = document.getElementById('fa-product-extras-config');
  var locale = document.documentElement.getAttribute('lang') || '';
  if (configNode) {
    try {
      locale = String((JSON.parse(configNode.textContent) || {}).locale || locale);
    } catch (e) {}
  }

  var bg = locale.toLowerCase().indexOf('bg') === 0;
  var copy = bg ? {
    title: 'Бърза доставка',
    lead: 'Очаквана доставка между тези дати',
    tomorrow: 'Утре',
    rangeTo: 'до',
    beforeCutoff: 'Поръчайте до 14:00 за този прозорец',
    afterCutoff: 'След 14:00 · показваме следващия наличен прозорец',
    sunday: 'Неделя е неработен ден · показваме следващите работни дни',
    divider: 'Доставка',
    carriers: 'Куриерски опции',
    carrierDetail: 'До офис или адрес'
  } : {
    title: 'Fast Delivery',
    lead: 'Expected delivery between these dates',
    tomorrow: 'Tomorrow',
    rangeTo: 'to',
    beforeCutoff: 'Order by 14:00 for this window',
    afterCutoff: 'After 14:00 · showing the next available window',
    sunday: 'Sunday is non-working · showing the next working days',
    divider: 'Delivery',
    carriers: 'Courier options',
    carrierDetail: 'Office pickup or delivery to your address'
  };

  var speedyLogo = 'https://cdn.shopify.com/s/files/1/0056/5670/7118/files/fabric-alex-speedy-transparent-final.png?v=1787994042';
  var econtLogo = 'https://cdn.shopify.com/s/files/1/0056/5670/7118/files/fabric-alex-econt-logo.svg?v=1787814411';

  function injectRefinementStyles() {
    if (document.getElementById('fa-product-extras-v9-refinements')) return;
    var style = document.createElement('style');
    style.id = 'fa-product-extras-v9-refinements';
    style.textContent = [
      '.fa-fast-delivery-divider{gap:9px;}',
      '.fa-fast-delivery-divider__line{height:1px;background:rgba(127,23,53,.2);}',
      '.fa-fast-delivery-divider__label{min-height:30px;padding:6px 16px;border:1px solid #7f1735;border-radius:8px;background:#7f1735;color:#fffaf1;box-shadow:0 6px 14px rgba(127,23,53,.16);}',
      '.fa-fast-delivery__eyebrow{background:linear-gradient(135deg,#7f1735,#a12c4c);color:#fffaf1;border:1px solid rgba(127,23,53,.2);box-shadow:0 5px 12px rgba(127,23,53,.14),inset 0 1px 0 rgba(255,255,255,.18);}',
      '.fa-fast-delivery__eyebrow:empty{display:none;}',
      '.fa-fast-delivery__eyebrow:empty+.fa-fast-delivery__day,.fa-fast-delivery__date-card--second .fa-fast-delivery__day{margin-top:0;}',
      '.fa-fast-delivery__connector .fa-fast-delivery__range-word{display:inline-flex;align-items:center;justify-content:center;width:auto;min-width:24px;min-height:24px;padding:3px 6px;border:0;border-radius:999px;background:rgba(11,61,99,.065);color:rgba(11,34,61,.56);font-size:9.5px;font-weight:900;line-height:1;letter-spacing:.045em;text-transform:uppercase;}',
      '@media screen and (max-width:410px){.fa-fast-delivery-divider__label{min-height:28px;padding:5px 13px;border-radius:7px}.fa-fast-delivery__connector .fa-fast-delivery__range-word{display:inline-flex;width:auto;min-width:20px;min-height:20px;padding:3px 4px;font-size:8.5px}}',
      '@media screen and (max-width:350px){.fa-fast-delivery__connector .fa-fast-delivery__range-word{display:inline-flex;width:auto;min-width:16px;min-height:18px;padding:2px 3px;font-size:8px}}'
    ].join('');
    document.head.appendChild(style);
  }

  injectRefinementStyles();

  function deliveryMarkup() {
    return '<div class="fa-fast-delivery-divider" aria-hidden="true">' +
      '<span class="fa-fast-delivery-divider__line"></span>' +
      '<span class="fa-fast-delivery-divider__label">' + copy.divider + '</span>' +
      '<span class="fa-fast-delivery-divider__line"></span>' +
    '</div>' +
    '<section class="fa-fast-delivery" data-fa-fast-delivery aria-label="' + copy.title + '">' +
      '<div class="fa-fast-delivery__top">' +
        '<span class="fa-fast-delivery__icon" aria-hidden="true">' +
          '<svg viewBox="0 0 32 32" fill="none"><path d="M4.5 9.5h14v12h-14z" stroke="currentColor" stroke-width="2"/><path d="M18.5 13h4.7l4.3 4.4v4.1h-9" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="10" cy="23.5" r="2.5" stroke="currentColor" stroke-width="2"/><circle cx="23.5" cy="23.5" r="2.5" stroke="currentColor" stroke-width="2"/><path d="M9 6.5h9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="m15.8 12.2-3.3 4.3h2.8l-2.3 4.3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</span>' +
        '<span class="fa-fast-delivery__heading">' +
          '<strong class="fa-fast-delivery__title">' + copy.title + '</strong>' +
          '<span class="fa-fast-delivery__lead">' + copy.lead + '</span>' +
        '</span>' +
      '</div>' +
      '<div class="fa-fast-delivery__window" aria-live="polite" aria-atomic="true">' +
        '<span class="fa-fast-delivery__date-card fa-fast-delivery__date-card--first">' +
          '<span class="fa-fast-delivery__eyebrow" data-fa-delivery-label="first"></span>' +
          '<span class="fa-fast-delivery__day" data-fa-delivery-day="first">—</span>' +
          '<span class="fa-fast-delivery__date" data-fa-delivery-date="first">—</span>' +
        '</span>' +
        '<span class="fa-fast-delivery__connector" aria-hidden="true">' +
          '<span class="fa-fast-delivery__range-word">' + copy.rangeTo + '</span>' +
        '</span>' +
        '<span class="fa-fast-delivery__date-card fa-fast-delivery__date-card--second">' +
          '<span class="fa-fast-delivery__day" data-fa-delivery-day="second">—</span>' +
          '<span class="fa-fast-delivery__date" data-fa-delivery-date="second">—</span>' +
        '</span>' +
      '</div>' +
      '<div class="fa-fast-delivery__note" data-fa-delivery-note></div>' +
      '<div class="fa-fast-delivery__carrier">' +
        '<span class="fa-fast-delivery__carrier-icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" fill="none"><path d="M5 7.5 12 4l7 3.5v9L12 20l-7-3.5v-9Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="m5.5 8 6.5 3.3L18.5 8M12 11.3V20" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M9 5.5 15.5 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
        '</span>' +
        '<span class="fa-fast-delivery__carrier-copy">' +
          '<strong>' + copy.carriers + '</strong>' +
          '<span>' + copy.carrierDetail + '</span>' +
        '</span>' +
        '<span class="fa-fast-delivery__logos">' +
          '<img class="fa-fast-delivery__logo fa-fast-delivery__logo--speedy" src="' + speedyLogo + '" alt="Speedy" loading="lazy">' +
          '<img class="fa-fast-delivery__logo fa-fast-delivery__logo--econt" src="' + econtLogo + '" alt="Econt" loading="lazy">' +
        '</span>' +
      '</div>' +
    '</section>';
  }

  var mount = document.querySelector('[data-fa-fast-delivery-mount]');
  if (!mount || mount.querySelector('[data-fa-fast-delivery]')) return;
  mount.innerHTML = deliveryMarkup();

  var delivery = mount.querySelector('[data-fa-fast-delivery]');
  if (!delivery) return;

  function addDays(date, amount) {
    var next = new Date(date.getTime());
    next.setUTCDate(next.getUTCDate() + amount);
    return next;
  }

  function isSunday(date) {
    return date.getUTCDay() === 0;
  }

  function nextWorkingDay(date) {
    var next = addDays(date, 1);
    while (isSunday(next)) next = addDays(next, 1);
    return next;
  }

  function sameDate(a, b) {
    return a.getUTCFullYear() === b.getUTCFullYear() && a.getUTCMonth() === b.getUTCMonth() && a.getUTCDate() === b.getUTCDate();
  }

  function sofiaClock() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Sofia',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date());
      var values = {};
      parts.forEach(function (part) { if (part.type !== 'literal') values[part.type] = part.value; });
      return { date: new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day))), hour: Number(values.hour) };
    } catch (e) {
      var now = new Date();
      return { date: new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())), hour: now.getHours() };
    }
  }

  function pad(value) { return String(value).padStart(2, '0'); }
  function dateText(date) { return pad(date.getUTCDate()) + '.' + pad(date.getUTCMonth() + 1) + '.' + date.getUTCFullYear(); }
  function weekdayText(date) {
    var daysBg = ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота'];
    var daysEn = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return (bg ? daysBg : daysEn)[date.getUTCDay()];
  }
  function setText(selector, value) { var node = delivery.querySelector(selector); if (node) node.textContent = value; }

  function renderDelivery() {
    var clock = sofiaClock();
    var today = clock.date;
    var tomorrow = addDays(today, 1);
    var afterCutoff = !isSunday(today) && clock.hour >= 14;
    var first = nextWorkingDay(today);
    if (afterCutoff) first = nextWorkingDay(first);
    var second = nextWorkingDay(first);
    var firstIsTomorrow = sameDate(first, tomorrow);

    setText('[data-fa-delivery-label="first"]', firstIsTomorrow ? copy.tomorrow : '');
    setText('[data-fa-delivery-day="first"]', weekdayText(first));
    setText('[data-fa-delivery-date="first"]', dateText(first));
    setText('[data-fa-delivery-day="second"]', weekdayText(second));
    setText('[data-fa-delivery-date="second"]', dateText(second));
    setText('[data-fa-delivery-note]', isSunday(today) ? copy.sunday : (afterCutoff ? copy.afterCutoff : copy.beforeCutoff));
    delivery.setAttribute('data-fa-after-cutoff', afterCutoff ? 'true' : 'false');
  }

  renderDelivery();
  window.setInterval(renderDelivery, 60000);
})();
